import ExportOutlined from "@ant-design/icons/es/icons/ExportOutlined";
import { Badge, Row, Tooltip } from "antd";
import { ReactNode } from "react";
export const MenuItem = ({
  icon,
  isSidebarCollapsed = false,
  toolLabel,
  isExternal,
  selected,
  badgeLabel
}: {
  icon?: ReactNode;
  isSidebarCollapsed?: boolean;
  toolLabel: string;
  isExternal: boolean;
  selected?: boolean;
  badgeLabel?: string;
}) => {
  const label = () => <Row className={`!flex-1 overflow-y-visible ${selected ? "font-semibold text-gray-900 opacity-90" : "text-gray-500"}`} align="middle" justify="space-between" data-sentry-element="Row" data-sentry-component="label" data-sentry-source-file="MenuItem.tsx">
      {badgeLabel ? <Badge className="z-999" dot classNames={{
      indicator: "text-red-600"
    }} offset={[10, 3]} size="medium">
          {toolLabel}
        </Badge> : toolLabel}
      {isExternal && <ExportOutlined className="[&_svg]:m-0! [&_svg]:text-base! opacity-50" />}
    </Row>;
  return <Tooltip title={isSidebarCollapsed ? `${toolLabel} ${badgeLabel ? `(${badgeLabel})` : ""}` : null} placement="right" align={!isSidebarCollapsed ? {
    offset: [24, 0]
  } : undefined} data-sentry-element="Tooltip" data-sentry-component="MenuItem" data-sentry-source-file="MenuItem.tsx">
      <div className="flex w-full items-center gap-2 text-gray-500">
        <span className={`flex items-center ${selected ? "text-gray-800 opacity-90" : "text-gray-500"} *:!text-lg`}>
          {icon}
        </span>
        {label()}
      </div>
    </Tooltip>;
};